import { render } from "./TogglePanneau.vue?vue&type=template&id=367ef0fa"
import script from "./TogglePanneau.vue?vue&type=script&lang=js"
export * from "./TogglePanneau.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__